// extracted by mini-css-extract-plugin
export default {"container":"loading_container__f65Um","loading-animation":"loading_loading-animation__R0zHa","rect":"loading_rect__zFgh9","img":"loading_img__qnBSH"};